import { api, API } from "./api";

/** Submit a brand-new architect application. */
export async function submitApplication(payload) {
  const { data } = await api.post("/architect-applications", payload);
  return data; // { application, user }
}

/** Resubmit a more_info_requested application. */
export async function resubmitApplication(applicationId, payload) {
  const { data } = await api.post(
    `/architect-applications/${encodeURIComponent(applicationId)}/resubmit`,
    payload
  );
  return data;
}

/** List queue (admin). */
export async function listApplications(adminUserId, state) {
  const params = { user_id: adminUserId };
  if (state && state !== "all") params.state = state;
  const { data } = await api.get("/architect-applications", { params });
  return data;
}

export async function getApplication(applicationId) {
  const { data } = await api.get(
    `/architect-applications/${encodeURIComponent(applicationId)}`
  );
  return data;
}

export async function applicationByUser(userId) {
  const { data } = await api.get(
    `/architect-applications/by-user/${encodeURIComponent(userId)}`
  );
  return data;
}

/** Admin decision — action: 'approve' | 'reject' | 'request_more_info'. */
export async function decideApplication(applicationId, payload) {
  const { data } = await api.patch(
    `/architect-applications/${encodeURIComponent(applicationId)}/decision`,
    payload
  );
  return data;
}

/** Open the CSV export in a new tab. */
export function exportApplicationsCsvUrl(adminUserId) {
  return `${API}/architect-applications/export.csv?user_id=${encodeURIComponent(
    adminUserId
  )}`;
}

/** Upload a file (multipart). Returns the file metadata. */
export async function uploadFile(file, purpose) {
  const form = new FormData();
  form.append("file", file);
  if (purpose) form.append("purpose", purpose);
  const { data } = await api.post("/uploads", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

/** Returns architect users whose accounts are non-active — for the resume picker. */
export async function listArchitectApplicants() {
  const { data } = await api.get("/architect-applicants");
  return data;
}
